module.exports = __webpack_public_path__ + "img/VoitureOld.3d58cde8.png";